import ContentLayout from '@/layouts/content-layout'
import DashboardView from '@/sections/dashboard/view/dashboard-view'

export default function Dashboard() {
  return (
    <ContentLayout title="แดชบอร์ด">
      <DashboardView />
    </ContentLayout>
  )
}
